import i18n from "../i18n/i18n";

export function getNotificationMessage(code: string, values: Record<string, string>) {
    const codesWithTimeProperty = new Set([
        "TICKET_REGISTERED_NEAR_END_OF_LOADING_TIME",
        "ORDER_REGISTERED_NEAR_END_OF_LOADING_TIME",
        "VEHICLE_ENTERED_JUST_BEFORE_PARKING_CLOSE",
        "NEAR_TIME_TO_FERRY_DEPARTURE"
    ]);
    if (!code) {
        return null;
    } else if (codesWithTimeProperty.has(code) && Object.prototype.hasOwnProperty.call(values, "time")) {
        return `${i18n.t(`alerts.notifications.${code}`, {time: values["time"]})}`;
    } else {
        return i18n.t(`alerts.notifications.${code}`);
    }
}